
    <div class="choose-module-container" *ngIf="!element.openingModuleId">Modul auswählen</div>
    <ng-container *ngIf="element.openingModuleId && entity && entity.id && element.datamodelField">
      <app-content-renderer [(entity)]="entity" [masterField]="element.datamodelField" [moduleId]="element.openingModuleId"></app-content-renderer>
    </ng-container>
    <ng-container *ngIf="element.openingModuleId && (!entity || !entity.id)">
        <app-content-renderer [moduleId]="element.openingModuleId" [masterField]="element.datamodelField"></app-content-renderer>
    </ng-container>
  